"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValuesFromKeys = void 0;
function getValuesFromKeys(keys, values) {
    const keyFields = Object.keys(keys[0]);
    const map = values.reduce((map, value) => {
        map.set(getKey(value, keyFields), value);
        return map;
    }, new Map());
    return keys.map((key) => map.get(getKey(key, keyFields)));
}
exports.getValuesFromKeys = getValuesFromKeys;
function getKey(key, keyFields) {
    return keyFields
        .map((keyField) => key[keyField].replaceAll('::', '\\:\\:'))
        .join('::');
}
